import { Injectable } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { Basket } from '@df/session/api/basket/basket';
import { BasketItem } from '@df/session/api/basket/basket-item';
import { EAttrSet, Product } from '../catalog/product/product.decorator';
import { NFurnitureAssembly } from '../module/furniture-assembly/furniture-assembly.namespace';

declare module '@tomandco/nexus-api-types' {
    namespace Nexus.Lib.Basket {

        interface BasketData {
            protection_plan_ids?: {
                [planId: number]: {
                    plan_type: string;
                    covered_products: number[];
                };
            };
            assembly?: {
                garden?: NFurnitureAssembly.IBasketDataConfigurationItem;
                sofa?: NFurnitureAssembly.IBasketDataConfigurationItem;
            };
        }

        interface Totals {
            assembly?: number;
            discount_success_message?: string[];
            discounts_applied?: number;
        }
    }
}


@Injectable({
    providedIn: 'root'
})
export class LocalBasket extends Basket {
    get protectionPlansData(): { [planId: number]: { plan_type: string; covered_products: number[] } } {
        const data = this.data?.protection_plan_ids || {};
        return data;
    }

    get protectionPlansIds(): number[] {
        const plansData = this.protectionPlansData;
        const ids = Object.keys(plansData).map(id => parseInt(id, 10));
        return ids;
    }

    get protectionPlansByType(): { [planType: string]: number[] } {
        const plansData = this.protectionPlansData;
        const result: { [planType: string]: number[] } = {};

        Object.entries(plansData).forEach(([planId, planData]) => {
            const planType = planData.plan_type;
            if (!result[planType]) {
                result[planType] = [];
            }
            result[planType].push(parseInt(planId, 10));
        });

        return result;
    }

    getProductsForPlan(planId: number): number[] {
        const plansData = this.protectionPlansData;
        const products = plansData[planId]?.covered_products || [];
        return products;
    }

    get hasGardenAssembly(): BasketItem<Product<IProductDataV3>> | undefined {
        return this.items.find(item => item.product?.data?.attribute_set === EAttrSet.assemblyPlan) as BasketItem<Product<IProductDataV3>>;
    }
}
